import React from 'react';
import PropTypes from 'prop-types';

import { MediaWrapper } from './styles';

const VideoPreview = ({ urlMetadata, progress }) => (
  <MediaWrapper opacity={1 - progress / 100}>
    <video controlsList="nodownload nofullscreen noremoteplayback" controls muted autoPlay loop playsInline disablePictureInPicture preload="auto">
      <source src={urlMetadata} type="video/mp4" />
    </video>
  </MediaWrapper>
);

VideoPreview.defaultProps = {
  progress: 0,
};

VideoPreview.propTypes = {
  progress: PropTypes.number,
  urlMetadata: PropTypes.string.isRequired,
};
export default VideoPreview;
